module.exports = __webpack_public_path__ + "static/media/Sbu-logo.acc5045d.png";